const { EMPTY_ARRAY } = require('../../../../components/utils/sync');

/** ************************
 * HELPERS
 */

const isDefined = v => v !== undefined && v !== null;

/** ************************
 * WRITE
 */

export const createKey = (flatGpsReading = {}) => {
	const { coordinates = [], reading1, reading2 } = flatGpsReading;
	const [lat, lon] = coordinates;
	return [lat, lon, reading1, reading2].filter(v => isDefined(v)).join('~');
};

export const createIndexMap = (gpsReadingsFlat = []) => {
	const indexMap = {};

	gpsReadingsFlat.reduce((acc, r, idx) => {
		const key = createKey(r);
		acc[key] = acc[key] || [];
		acc[key].push(idx);
		return acc;
	}, indexMap);

	return indexMap;
};

/** ************************
 * READ
 */

const _getKeyFromKeyOrReading = keyOrReading => {
	if (typeof keyOrReading === 'string') {
		return keyOrReading; // this has been identified as a key, simply return the key
	}

	// else assume reading obj
	return createKey(keyOrReading);
};

export const hasDuplicateIndexes = (indexMap, keyOrReading) => {
	const key = _getKeyFromKeyOrReading(keyOrReading);
	return (indexMap[key] || []).length > 1;
};

export const getIndexes = (indexMap = {}, keyOrReading) => {
	const key = _getKeyFromKeyOrReading(keyOrReading);
	return indexMap[key] || EMPTY_ARRAY;
};

// dangerous, will break if we have duplicate readings.
export const getIndex = (indexMap = {}, keyOrReading) => {
	const key = _getKeyFromKeyOrReading(keyOrReading);

	if (hasDuplicateIndexes(indexMap, key)) {
		console.error('This key points to multiple indexes');
		// throw new Error('This key points to multiple indexes');
	}

	return getIndexes(indexMap, key)[0];
};

/** ************************
 * EXPORT
 */

const UTIL_INDEX_MAP = {
	// WRITE
	createKey,
	createIndexMap,

	// READ
	hasDuplicateIndexes,
	getIndexes,
	getIndex // dangerous, will break if we have duplicate readings.
};

export default UTIL_INDEX_MAP;
